module.exports = __webpack_public_path__ + "static/banner-mobile-e4e78f7d23d9383bd3af28b2350ebb17.png";